@let appsVal = apps();

@let coreHrApp = appsVal.core_hr;
@let recruitmentApp = appsVal.recruitment;
@let adminApp = appsVal.admin;

<rt-dropdown [width]="$any(TELLENT_APP_SHELL_LAYOUT.sidebarExpandedWidth - 16 + 'px')">
  @if (coreHrApp) {
    <rt-dropdown-item>
      <a
        class="item item--brand"
        [href]="urlBuilder(AppKind.KiwiHr, undefined, ORG_GUID)"
        data-cy="app-switcher:item:hr"
      >
        <tlc-app-logo [brand]="TellentBrand.Kiwi" [isTaglineVisible]="false" />
        <div class="title">
          {{ 'tlc.app_switcher.apps.hr' | translate }}&nbsp;<span>{{
            'tlc.app_switcher.apps.hr_type' | translate
          }}</span>
        </div>
        @if (coreHrApp.active) {
          <rt-icon name="check" colorToken="colorIconSuccessDefault" />
        }
      </a>
    </rt-dropdown-item>
  }

  @if (recruitmentApp) {
    <rt-dropdown-item>
      <a
        class="item item--brand"
        [href]="urlBuilder(AppKind.Recruitee, undefined, ORG_GUID)"
        data-cy="app-switcher:item:ats"
      >
        <tlc-app-logo [brand]="TellentBrand.Recruitee" [isTaglineVisible]="false" />
        <div class="title">
          {{ 'tlc.app_switcher.apps.recruitee' | translate }}&nbsp;<span>{{
            'tlc.app_switcher.apps.recruitee_type' | translate
          }}</span>
        </div>
        @if (recruitmentApp.active) {
          <rt-icon name="check" colorToken="colorIconSuccessDefault" />
        }
      </a>
    </rt-dropdown-item>

    @if (recruitmentApp.data.referralProgram?.enabled) {
      <rt-dropdown-item>
        <a
          class="item item--default"
          data-cy="app-switcher:item:referrals"
          [href]="urlBuilder(AppKind.Recruitee, { id: 'referrals' }, ORG_GUID)"
        >
          <div class="icon-outer">
            <rt-icon
              name="navbar-referrals"
              [size]="'small-xx'"
              colorToken="colorIconPrimaryDefault"
            />
          </div>
          <div class="title">{{ 'tlc.app_switcher.apps.referrals_hub' | translate }}</div>
        </a>
      </rt-dropdown-item>
    }

    @if (recruitmentApp.data.careersSite?.enabled) {
      <rt-dropdown-item>
        <a
          class="item item--default"
          data-cy="app-switcher:item:careers_editor"
          [href]="urlBuilder(AppKind.Recruitee, { id: 'careers_editor' }, ORG_GUID)"
        >
          <div class="icon-outer">
            <rt-icon
              name="nav-careershub"
              [size]="'small-xx'"
              colorToken="colorIconPrimaryDefault"
            />
          </div>
          <div class="title">{{ 'tlc.app_switcher.apps.careers_builder' | translate }}</div>
        </a>
      </rt-dropdown-item>

      <rt-divider class="with-margin" />

      <rt-dropdown-item [rtWalkthroughOriginStepId]="'walkthrough-step-navigation-3'">
        <a
          class="item item--careers"
          data-cy="app-switcher:item:careers_site"
          [href]="urlBuilder(AppKind.Recruitee, { id: 'careers' }, ORG_GUID)"
          target="_blank"
        >
          <div class="icon-outer blank">
            <rt-icon name="dot" [size]="'small-xx'" colorToken="colorIconSuccessDefault" />
          </div>
          <div class="title">
            <div>{{ 'tlc.app_switcher.apps.careers_site' | translate }}</div>
            <span
              ><rt-truncate>{{ recruitmentApp.data.careersSite?.url }}</rt-truncate></span
            >
          </div>
          <rt-icon name="open-in-new" />
        </a>
      </rt-dropdown-item>
    }
  }

  @if (adminApp) {
    @let settingsRouteVal = settingsRoute();
    <rt-divider />

    <rt-dropdown-item>
      <a
        class="item item--default"
        data-cy="app-switcher:item:settings"
        [href]="settingsRouteVal"
        (click)="navigateToSettings($event, settingsRouteVal)"
      >
        @if (isOneSettingsEnabled) {
          <div class="icon-outer blank">
            <rt-icon name="settings" [size]="'small-x'" />
          </div>
          <div class="title">{{ 'tlc.app_switcher.apps.settings' | translate }}</div>
        } @else {
          <div class="icon-outer blank">
            <rt-icon name="tellent-apps-tellent-admin" [size]="'small-x'" />
          </div>
          <div class="title">{{ 'tlc.app_switcher.apps.tellent_admin' | translate }}</div>
        }

        @if (adminApp.active) {
          <rt-icon name="check" colorToken="colorIconSuccessDefault" />
        }
      </a>
    </rt-dropdown-item>
  }
</rt-dropdown>
